import { useAuthStore } from '~/store/auth'

const PUBLIC_PATHS = new Set([
  '/auth/login',
  '/auth/login/',
  '/auth/logout',
  '/auth/logout/',
  '/auth/register',
  '/auth/register/',
  '/verify-email',
  '/verify-email/',
  '/demo',
  '/demo/',
  // Invite acceptance: a new invitee has no session yet (the page logs them in).
  '/invite',
  '/invite/',
])

export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore()

  // Legal pages (/podminky/…) are public — linked from the landing page footer.
  // /d/<token> is the SMS demo link for cold-call leads (pages/d/[token].vue →
  // /demo?lead=…): the customer has no account yet (AUDIT L1).
  if (
    PUBLIC_PATHS.has(to.path) ||
    to.path.startsWith('/podminky') ||
    to.path.startsWith('/zavolali-jsme') ||
    to.path.startsWith('/d/')
  ) {
    return
  }

  if (!authStore.user) {
    try {
      await authStore.loadMe()
    } catch (e) {
      // Keep the target (invoice / poptávka / support links from e-mails) so
      // the login page can return there instead of the dashboard (AUDIT L2).
      const next = to.fullPath && to.fullPath !== '/' ? { next: to.fullPath } : undefined
      return navigateTo({ path: '/auth/login', query: next })
    }
  }

  const user = authStore.user
  if (user?.must_change_password && to.path !== '/account/password') {
    return navigateTo('/account/password')
  }

  if (to.path.startsWith('/admin') && !user?.is_admin_role) {
    return navigateTo('/')
  }
})
